import { useContext, useState  } from "react";
import { Plus, Minus, Mail, Clock, MapPin, Phone, Send, MessageCircle, User, ClipboardList } from 'lucide-react';

import facebookIcon from "../assets/img/socialfacebook.png";
import googleIcon from "../assets/img/socialgoogle.png";
import appleIcon from "../assets/img/socialapple.png";
import instaIcon from "../assets/img/socialinsta.png";
import "../assets/css/style.css"; // Adjust path if needed
import bannerImage from "../assets/img/ban1.jpg";
import Banner from '../components/Banner';
import bannerimg from "../assets/img/contactbanner.jpg";
import Faqsection from '../components/Faqsection';


import bginfoimg from "../assets/img/cotactimg.jpg";
import contactImg from "../assets/img/contactbg.jpg";
import experts from "../assets/img/experts-i.svg";
import research from "../assets/img/research-i.svg";
import professional from "../assets/img/professional-i.svg";




// Autocomplete Component
const Autocomplete = ({ id, label, source, tags, setTags }) => {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value) {
      setSuggestions(source.filter(item => item.toLowerCase().includes(value.toLowerCase()) && !tags.includes(item)));
    } else {
      setSuggestions([]);
    }
  };

  const addTag = (item) => {
    if (!tags.includes(item)) {
      setTags([...tags, item]);
    }
    setInputValue('');
    setSuggestions([]);
  };

  const removeTag = (item) => {
    setTags(tags.filter(tag => tag !== item));
  };

  return (
    <div className="mb-4">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">{label}</label>
      <input
        id={id}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
        placeholder="Please input"
      />
      {suggestions.length > 0 && (
        <div className="absolute bg-white border border-gray-300 rounded-md mt-1 max-h-48 overflow-y-auto w-full z-10">
          {suggestions.map((suggestion, index) => (
            <div
              key={index}
              className="px-4 py-2 cursor-pointer hover:bg-gray-100"
              onClick={() => addTag(suggestion)}
            >
              {suggestion}
            </div>
          ))}
        </div>
      )}
      <div className="mt-2 flex flex-wrap gap-2">
        {tags.map((tag, index) => (
          <div key={index} className="inline-flex items-center bg-gray-200 rounded-full px-3 py-1 text-sm">
            {tag}
            <span className="ml-2 cursor-pointer text-red" onClick={() => removeTag(tag)}>×</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// Ap Component
const Ap = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_no: '',
    contact_method: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleSearch = () => {
    console.log('Search icon clicked, isSearchOpen:', !isSearchOpen); // Debug log
    setIsSearchOpen(prev => !prev);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setErrors({ ...errors, [id]: '' });
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.name.trim()) newErrors.name = 'First Name is required';
  //   if (!formData.email.trim()) newErrors.email = 'Email is required';
  //   else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Invalid email format';
  //   if (!formData.phone_no.trim()) newErrors.phone_no = 'Phone Number is required';
  //   if (!formData.contact_method) newErrors.contact_method = 'Contact Method is required';
  //   if (!formData.message.trim()) newErrors.message = 'Message is required';
  //   return newErrors;
  // };

  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!formData.name.trim()) {
      newErrors.name = 'First Name is required';
    } else if (!nameRegex.test(formData.name.trim())) {
      newErrors.name = 'Name should contain only alphabets';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email.trim())) {
      newErrors.email = 'Enter a valid email address';
    }

    if (!formData.phone_no.trim()) {
      newErrors.phone_no = 'Phone Number is required';
    } else if (!phoneRegex.test(formData.phone_no.trim())) {
      newErrors.phone_no = 'Phone Number must be exactly 10 digits';
    }

    if (!formData.contact_method) {
      newErrors.contact_method = 'Contact Method is required';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    return newErrors;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsLoading(true);
    setSubmitMessage('');

    try {
      // const response = await fetch('http://localhost:5000/api/contact_us', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(formData),
      // });

      // const result = await response.json();

      const base = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

      const response = await fetch(`${base}/api/contact_us`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json().catch(() => ({}));


      if (response.ok) {
        setSubmitMessage('Form submitted successfully!');
        setFormData({
          name: '',
          email: '',
          phone_no: '',
          contact_method: '',
          message: ''
        });
        setErrors({});
      } else {
        setSubmitMessage(result.error || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmitMessage('An error occurred while submitting the form');
    } finally {
      setIsLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };



  const cards = [
        {
        icon: experts,
        text: "Ask questions to industry experts",
        },
        {
        icon: research,
        text: "Share your professional insights",
        },
        {
        icon: professional,
        text: "Participate in research survey",
        },
    ];

    const faqs = [
        {
            question: "What is Industry & People?",
            answer:"Industry & People is a research platform that connects professionals and organizations through industry-specific surveys, offering real insights for better decisions. It also lets you create surveys based on your own needs.",
        },
        {
            question: "How do Industry & People work?",
            answer:"Join Industry & People to explore insights across diverse industries, take part in tailored surveys, and contribute to research that drives real impact—while earning an honorarium for your participation. ",
        },
        {
            question: "Who can join Industry & People? ",
            answer:"Professionals, experts, and individuals from any industry can join—whether you’re in healthcare, finance, education, technology, or any other sector. Your unique experience helps shape meaningful insights. ",
        },
    ];

    const [openIndex, setOpenIndex] = useState(0); // first one open by default
    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };



  return (
    <div>
      <div id="wrapper">

        <Banner
            title=" Get in Touch"
            highlight=""
            subtitle={
                <>
                <span className="mb-2 block">Research becomes powerful when insights are shared. </span> 
                At Industry & People (I&P), we connect professionals who believe in asking the right questions, sharing knowledge, and shaping industries together.
                </>
            }
            primaryBtn={{
                text: "Apply to join the Community",
                link: "/apply",
                bgcolor: "bg-[#C72430] mt-4",
                hoverbgcolor: "hover:bg-[#fff] hover:text-[#C72430]"
            }}
            bgImage={bannerimg}   
            containerWidth="w-50" 
            headingcenter="text-center"            
        />
        
        <section className="bglightgray ptb60px px-3 prtext">
          <div className="container m-auto">

              {/* Heading */}
              <div className="mb-5" data-aos="fade-up">
                  <h2 className="headinglg text-[#323539]">
                      Let's Connect
                  </h2>
                  <p className="mb-0" style={{ color: "#2B2D2F" }}>
                      Have a question, idea, or perspective to share?
                  </p>
                  <p className="" style={{ color: "#2B2D2F" }}>
                      <strong> We'd love to hear from you.</strong>
                  </p>
              </div>

              {/* Contact Box */}
              <div data-aos="fade-up"
              className="addboxcol"
              style={{
                  backgroundImage: `url(${bginfoimg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
              }}
              >
                {/* Overlay */}
                <div className="overlayone"></div>

                <div className="prrelative mb-3">
                    {/* Title */}
                    <div className="addboxrow">
                      <div className="iconbox">
                          <Phone size={18} />
                      </div>
                      <h3 className="h3heading">Contact Information</h3>
                    </div>

                    {/* Cards */}
                    <div className="row g-3 g-md-4">

                      {/* Email */}
                      <div className="col-12 col-sm-6 col-lg-4">
                        <div className="bg-white bg-opacity-90 rounded-4 p-4 p-md-4 d-flex gap-3 align-items-start">
                          
                          <Mail className="text-danger" size={20} />

                          <div>
                            <h4 className="fw-semibold text-dark mb-1">Email</h4>
                            <p className="small text-dark mb-0">
                              support@inpcommunity.com
                            </p>
                          </div>

                        </div>
                      </div>

                      {/* Response Time */}
                      <div className="col-12 col-sm-6 col-lg-4">
                        <div className="bg-white bg-opacity-90 rounded-4 p-4 p-md-4 d-flex gap-3 align-items-start">
                          
                          <Clock className="text-danger" size={20} />

                          <div>
                            <h4 className="fw-semibold text-dark mb-1">
                              Response Time
                            </h4>
                            <p className="small text-dark mb-0">
                              Within 24–48 hours
                            </p>
                          </div>

                        </div>
                      </div>

                      {/* Address */}
                      <div className="col-12 col-sm-6 col-lg-4">
                        <div className="bg-white bg-opacity-90 rounded-4 p-4 p-md-4 d-flex gap-3 align-items-start">
                          
                          <MapPin className="text-danger" size={20} />

                          <div>
                            <h4 className="fw-semibold text-dark mb-1">Address</h4>
                            <p className="small text-dark mb-0">
                              UK, USA, India (Noida)
                            </p>
                          </div>

                        </div>
                      </div>

                    </div>
                </div>
              </div>

          </div>
        </section>

        <section className="inntersectionouter ptb60px" id="inner_section" >
          <div className="container">
              <div className="row pb-3">
                <div className="col-lg-12">
                  <div className="mb-8" data-aos="fade-up">
                        <h2 className="headinglg" style={{ color: "#2B2D2F" }}>
                            Our Approach
                        </h2>
                        <p className="fst-italic fs17px" style={{ color: "#E33B32" }}>
                            We are building a professional ecosystem where people help each other make smarter, faster, and more informed decisions.
                        </p>
                        <p className="fst-italic fs17px" style={{ color: "#E33B32" }}>
                            Every question, every insight, and every interaction adds value.
                        </p>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-lg-12">               

                  <div className="inner_wrapperdetail" data-aos="fade-up">
                    <div className="row">
                      <div className="col-lg-6 d-flex align-items-center justify-content-center">
                        <div className="contactimgfiger">
                        <img
                            src={contactImg}
                            alt="Contact"
                            className=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="contactusformbox">
                          <h2 className="headinglg">Send Us a Message</h2>
                          <form id="contactForm" className="contactform" onSubmit={handleSubmit} noValidate>
                            <div className="row g-4">
                              <div className="col-md-12">
                                <label htmlFor="name" className="form-label">
                                  First Name
                                </label>
                                <input
                                  type="text"
                                  id="name"
                                  value={formData.name}
                                  onChange={handleChange}
                                  className={`form-control ${errors.name ? 'border-red-500' : ''}`}
                                  placeholder="Please input"
                                  
                                />
                                {errors.name && <p className="text-red text-sm mt-1">{errors.name}</p>}
                              </div>
                              <div className="col-md-12">
                                <label htmlFor="email" className="form-label">
                                  Email Address
                                </label>
                                <input
                                  type="email"
                                  id="email"
                                  value={formData.email}
                                  onChange={handleChange}
                                  className={`form-control ${errors.email ? 'border-red-500' : ''}`}
                                  placeholder="Please input"
                                  
                                />
                                {errors.email && <p className="text-red text-sm mt-1">{errors.email}</p>}
                              </div>
                              <div className="col-md-12">
                                <label htmlFor="phone_no" className="form-label">
                                  Phone Number
                                </label>
                                <input
                                  type="tel"
                                  id="phone_no"
                                  value={formData.phone_no}
                                  onChange={handleChange}
                                  className={`form-control ${errors.phone_no ? 'border-red-500' : ''}`}
                                  placeholder="+91 123456789"
                                  maxLength={10}
                                  inputMode="numeric"
                                />
                                {errors.phone_no && <p className="text-red text-sm mt-1">{errors.phone_no}</p>}
                              </div>
                              <div className="col-md-12">
                                <label htmlFor="contact_method" className="form-label">
                                  Contact Method
                                </label>
                                <select
                                  id="contact_method"
                                  className={`form-control ${errors.contact_method ? 'border-red-500' : ''}`}
                                  value={formData.contact_method}
                                  onChange={handleChange}
                                  
                                >
                                  <option value="" disabled>
                                    Choose method
                                  </option>
                                  <option value="email">Email</option>
                                  <option value="phone">Phone Call</option>
                                  <option value="message">Message</option>
                                </select>
                                {errors.contact_method && <p className="text-red text-sm mt-1">{errors.contact_method}</p>}
                              </div>
                              <div className="col-12">
                                <label htmlFor="message" className="form-label">
                                  Message
                                </label>
                                <textarea
                                  id="message"
                                  className={`form-control ${errors.message ? 'border-red-500' : ''}`}
                                  value={formData.message}
                                  onChange={handleChange}
                                  placeholder="Hi! We are..."
                                  style={{ minHeight: "120px" }}
                                ></textarea>
                                {errors.message && <p className="text-red text-sm mt-1">{errors.message}</p>}
                              </div>
                              <div className="col-12 text-end">
                                {submitMessage && (
                                  <p className={`text-sm mt-2 ${submitMessage.includes('successfully') ? 'text-green-500' : 'text-red'}`}>
                                    {submitMessage}
                                  </p>
                                )}
                                <div className="text-end mt-5">
                                  <button
                                    type="submit"
                                    className="submitbtton"
                                    disabled={isLoading}
                                  >
                                    {isLoading ? 'Submitting...' : 'Send Message'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
          </div>
        </section>

        <section className="ptb60px px-3 bglightgray">
          <div className="container" >

            {/* Heading */}
            <h2 className="headinglg px-6 text-left" style={{ color: "#323539" }} data-aos="fade-up">
              Be Part of the Conversation
            </h2>

            <p className="mb-5" style={{ color: "#2B2D2F" }} data-aos="fade-up">
              At InP, knowledge is not just consumed — it is created and shared.
            </p>

            {/* Cards */}
            <div className="row g-4 mb-5" data-aos="fade-up">
              {cards.map((item, index) => (
                <div key={index} className="col-12 col-sm-6 col-lg-4">
                  
                  <div
                    className="rounded-4 ptblr text-white d-flex flex-column align-items-center justify-content-center text-center h-100"
                    style={{
                      background: "linear-gradient(to bottom, #000000, #C72430)"
                    }}
                  >
                    
                    <div className="mb-3">
                      <img
                        src={item.icon}
                        alt="icon"
                        className="img-fluid"
                        style={{ width: "54px", height: "54px" }}
                      />
                    </div>

                    <h3
                      className="fw-bold mb-0"
                      style={{ fontSize: "24px", lineHeight: "27px" }}
                    >
                      {item.text}
                    </h3>

                  </div>

                </div>
              ))}
            </div>

            {/* Button */}
            <div className="text-center pt-3" data-aos="fade-up">
              <button
                className="btn text-white px-4 px-md-5 py-3 fs17px"
                style={{
                  backgroundColor: "#2f3337",
                  borderRadius: "8px",
                  transition: "all 0.3s ease"
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#C72430")}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#2f3337")}
              >
                Apply to Join the Community
              </button>
            </div>

          </div>
        </section>

        {/* <section className="ptb60px px-3 faqpage">
            <div className="container w-50">
        
                <div className="headingbox text-center mb-5" data-aos="fade-up">
                <h2 className="headinglg px-6 text-left" style={{ color: "#323539" }}>
                    <span className="uline">Have Questions? We've got answers!</span>
                </h2> 
        
                <p className="" style={{ color: "#746E6E" }}>
                    Find answers to the most commonly asked questions about inp.com
                </p>
                </div>
        
                <div className="row g-3" data-aos="fade-up">
                  {faqs.map((faq, index) => (
                    <div key={index} className="col-12" data-aos="fade-up">

                      <div className="border rounded overflow-hidden">

                        <button
                          className="w-100 d-flex justify-content-between align-items-center p-3 text-start fw-semibold"
                          style={{ fontSize: "18px", color: "#333" }}
                          onClick={() => toggleFAQ(index)}
                        >
                          {faq.question}

                          {openIndex === index ? (
                            <Minus size={22} className="text-secondary transition-icon" />
                          ) : (
                            <Plus size={22} className="text-secondary transition-icon" />
                          )}
                        </button>

                        <div
                          className={`faq-answer ${
                            openIndex === index ? "open" : ""
                          }`}
                        >
                          <p className="mb-0" style={{ fontSize: "16px", lineHeight: "24px", color: "#2B2D2F" }}>
                            {faq.answer}
                          </p>
                        </div>

                      </div>

                    </div>
                  ))}
                </div>
        
            </div>
        </section> */}

      </div>
    </div>
  );
};

export default Ap;